import { useAccount } from 'shared-ui/active-operation'
import { Forbidden403, Loading } from 'shared-ui/components'

export const AdminOnlyGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const account = useAccount()

  if (account.isPending) return <Loading />

  if (account.isError) {
    // this is already handled by AuthGuard, so we should not reach here
    throw account.error
  }

  if (!account.data.admin) {
    return (
      <div className="mx-12 my-20 md:mx-48">
        <Forbidden403 message="Only Panorama administrators can view this page. Please contact the development team if you believe you should have access to this page." />
      </div>
    )
  }

  return <>{children}</>
}
